import { apiClient } from './client';
import { ForceUpdate, CreateForceUpdateRequest, UpdateForceUpdateRequest, PaginatedResponse } from '../types';

export const forceUpdatesApi = {
  getForceUpdates: async (page = 1, limit = 10, appId?: number): Promise<PaginatedResponse<ForceUpdate>> => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });
    if (appId) {
      params.append('app_id', appId.toString());
    }
    return apiClient.get(`/admin/force-updates?${params.toString()}`);
  },

  createForceUpdate: async (forceUpdate: CreateForceUpdateRequest): Promise<ForceUpdate> => {
    return apiClient.post('/admin/force-updates', forceUpdate);
  },

  updateForceUpdate: async (appId: number, version: string, forceUpdate: UpdateForceUpdateRequest): Promise<ForceUpdate> => {
    return apiClient.put(`/admin/force-updates/${appId}/${version}`, forceUpdate);
  },

  deleteForceUpdate: async (appId: number, version: string): Promise<void> => {
    return apiClient.delete(`/admin/force-updates/${appId}/${version}`);
  },
};
